import React, { useCallback, useEffect, useState, useMemo } from "react";
import { io } from "socket.io-client";
import combinedServices from "../../shared/services/user-service";
import { NavLink, useLocation } from "react-router-dom";
import userConstants from "../../shared/constants/user-constants";
import "./HotPit.scss";
import checkPng from "../../../src/assets/images/check.png";
import logo from "../LiveFeed/logo.png";
import { Spinner } from "reactstrap";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SettingsIcon from "@mui/icons-material/Settings";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

export default function HotPit() {
  const [feeds, setFeeds] = useState([]);
  const [eventTitle, setEventTitle] = useState("");
  const [isLoader, setIsLoader] = useState(true);
  const [theme, setTheme] = useState("light");
  const [themeProp, setThemeProp] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [rotated, setRotated] = useState(false);

  const open = Boolean(anchorEl);

  const location = useLocation();
  const eventId = location.pathname.split("/")[2];

  const socket = useMemo(() => {
    return io.connect(userConstants.baseURL);
  }, []);

  const currentTime = useCallback(() => {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + ampm;
  }, []);

  useEffect(() => {
    let globalFeedArray = [];

    const fetchData = async () => {
      setIsLoader(true);
      try {
        const response = await combinedServices.getFeed({ eventId: eventId });
        const eventResponse = await combinedServices.getEventDetail(eventId);

        setEventTitle(eventResponse.data.event_full_title);

        for (let item of response) {
          if (item.case === 7 || item.case === 12) {
            let heatsheetResponse = await combinedServices.getHeatByHeatNumber(
              eventId,
              item.heat == 0 ? 1 : item.heat
            );
            heatsheetResponse = heatsheetResponse.data[0]?.participants;

            let heatStatusData = item.new_feed_text !== "" ? JSON.parse(item.new_feed_text) : {};
            let participants = [];

            for (let participant of heatsheetResponse) {
              let username = participant.event_participant_class.event_participant.user.user_firstname +
                " " + participant.event_participant_class.event_participant.user.user_lastname;
              let data = {
                username: username,
                scratch: participant.scratch ? "SCR" : "",
                onSpot: participant.on_spot,
                heatId: participant.id,
              };
              participants.push(data);
            }
            heatStatusData["participants"] = participants;
            item.new_feed_text = JSON.stringify(heatStatusData);
          }
        }
        setFeeds(response);
        globalFeedArray = response;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoader(false);
      }
    };

    fetchData();

    const handleUpdateFeed = async (newFeed) => {
      if (newFeed.event_Id == eventId) {
        if (newFeed.case === 7 || newFeed.case === 12) {
          let heatsheetResponse = (
            await combinedServices.getHeatByHeatNumber(eventId, newFeed.heat)
          ).data[0]["participants"];

          let heatStatusData = newFeed.new_feed_text !== "" ? JSON.parse(newFeed.new_feed_text) : {};
          let participants = [];

          for (let participant of heatsheetResponse) {
            let username = participant.event_participant_class.event_participant.user.user_firstname +
              " " + participant.event_participant_class.event_participant.user.user_lastname;
            let data = {
              username: username,
              scratch: participant.scratch ? "SCR" : "",
              onSpot: participant.on_spot,
              heatId: participant.id,
            };
            participants.push(data);
          }
          heatStatusData["participants"] = participants;
          newFeed.new_feed_text = JSON.stringify(heatStatusData);
        }
        globalFeedArray = [newFeed, ...globalFeedArray];
        setFeeds((prevFeeds) => [newFeed, ...prevFeeds]);
      }
    };

    const handleScratched = (scratchedHeatIds) => {
      const oldFeeds = [...globalFeedArray];
      for (let heatId of scratchedHeatIds) {
        for (let feed of oldFeeds) {
          if (feed.case === 7 || feed.case === 12) {
            let feedText = JSON.parse(feed.new_feed_text);
            let findIndex = feedText.participants.findIndex((participant) => participant.heatId == heatId.id);
            if (findIndex !== -1) {
              feedText.participants[findIndex]["scratch"] = heatId.scratch;
              feed.new_feed_text = JSON.stringify(feedText);
            }
          }
        }
      }
      setFeeds(oldFeeds);
    };

    const handleChecked = async (checkedParticipant) => {
      try {
        const oldFeeds = [...globalFeedArray];
        for (let feed of oldFeeds) {
          if (feed.case == 7 || feed.case == 12) {
            let feedText = JSON.parse(feed.new_feed_text);
            let findIndex = feedText.participants.findIndex((p) => p.heatId == checkedParticipant.id);
            if (findIndex !== -1) {
              feedText.participants[findIndex]["onSpot"] = checkedParticipant.checked;
              feed.new_feed_text = JSON.stringify(feedText);
            }
          }
        }
        setFeeds(oldFeeds);
      } catch (err) {
        console.log("err", err);
      }
    };

    socket.on("updateFeed", handleUpdateFeed);
    socket.on("scratched", handleScratched);
    socket.on("checked", handleChecked);

    return () => {
      socket.off("updateFeed", handleUpdateFeed);
      socket.off("scratched", handleScratched);
      socket.off("checked", handleChecked);
    };
  }, [eventId]);

  const onDeckHeat = feeds?.filter((feed) => feed.case == 7)?.slice(0, 1);
  const backupHeat = feeds?.filter((feed) => feed.case == 12)?.slice(0, 1);

  const handleMenuClick = (event) => {
    setRotated(!rotated);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setRotated(!rotated);
    setAnchorEl(null);
  };

  const handleThemeChange = () => {
    const currentTheme = theme;
    setTheme((prev) => (prev == "light" ? "dark" : "light"));
    if (currentTheme == "dark") {
      setThemeProp({});
    } else {
      setThemeProp({
        bgColor: "#000",
        headerFooterBg: "#525050",
        border: "1px solid #494848",
        textColor: "#fff",
        borderBottom: "1px solid #494848",
        spanYello: "#FFFF00",
      });
    }
  };

  return (
    <div className="hotpit-container" style={{ backgroundColor: themeProp.bgColor }}>
      {/* Banner */}
      <div className="hotpit-banner" style={{ backgroundColor: themeProp.headerFooterBg }}>
        <div className="banner-left">
          <div className="logo-section">
            <NavLink to="/">
              <img src={logo} alt="Logo" />
            </NavLink>
            <div className="event-title">{eventTitle}</div>
          </div>
        </div>
        <div className="banner-right">
          <span className="current-time">{currentTime()}</span>
          <Tooltip title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
            <IconButton
              onClick={handleThemeChange}
              size="small"
              sx={{ ml: 1 }}
            >
              {theme === 'light' ? (
                <DarkModeIcon sx={{ width: 25, height: 25, color: "white" }} />
              ) : (
                <LightModeIcon sx={{ width: 25, height: 25, color: "white" }} />
              )}
            </IconButton>
          </Tooltip>
          {/* 
          <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
            <Tooltip title="Theme settings">
              <IconButton
                onClick={handleMenuClick}
                size="small"
                sx={{
                  ml: 1,
                  transition: "transform 0.3s ease-in-out",
                  transform: rotated ? "rotate(60deg)" : "rotate(0deg)",
                }}
              >
                <SettingsIcon sx={{ width: 25, height: 25, color: "white" }} />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={handleThemeChange}>
              Change Theme
              <ListItemIcon>
                {theme == "dark   " ? <DarkModeIcon /> : <LightModeIcon />}
              </ListItemIcon>
            </MenuItem>
          </Menu>
          */}
          <NavLink
            to={`/live-feed/${eventId}`}
            className="live-feed-btn"
          >
            Live Feed
          </NavLink>
        </div>
      </div>

      {/* Main Content */}
      {isLoader ? (
          <div
            className="text-center loadMore"
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "auto",
              marginBottom: "auto",
            }}
          >
            <Spinner color="primary" />
          </div>
      ) : (
      <div className="hotpit-content">
        <div className="heat-sections">
          {/* On Deck Heat */}
          {onDeckHeat.length > 0 && (
            <div className="heat-section">
              {onDeckHeat.map((feed) => {
                const feedData = JSON.parse(feed.new_feed_text);
                return (
                  <div key={feed.id} className="heat-card">
                    <div className="heat-title" style={{ color: themeProp.textColor }}>
                      {feedData.title.split(" ")[0] + " " + feedData.title.split(" ")[1] + " "}
                      <span style={{ color: themeProp.spanYello }}>
                        {feedData.title.split(" ")[2] + " " + feedData.title.split(" ")[3]}
                      </span>
                    </div>
                    <div
                      className="heat-box"
                      style={{
                        border: themeProp.border || "1px solid #e8eaeb",
                        background: themeProp.bgColor || "#fff",
                        color: themeProp.textColor || "#000",
                      }}
                    >
                      <div className="heat-header" style={{ background: themeProp.headerFooterBg || "#f4f4f4" }}>
                        <div className="checkin-class-name">{feedData.className}</div>
                      </div>
                      <div className="participants-list">
                        {feedData.participants.map((participant, index) => (
                          <div
                            key={index}
                            className="participant-row"
                            style={{ borderBottom: themeProp.borderBottom || "1px solid #d0d0d0" }}
                          >
                            <div className="participant-name">{participant.username}</div>
                            <div className="participant-status">
                              {participant.onSpot ? (
                                <img src={checkPng} alt="On Spot" />
                              ) : (
                                <span>{participant.scratch || ""}</span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Backup Heat */}
          {backupHeat.length > 0 && (
            <div className="heat-section">
              {backupHeat.map((feed) => {
                const feedData = JSON.parse(feed.new_feed_text);
                return (
                  <div key={feed.id} className="heat-card">
                    <div className="heat-title" style={{ color: themeProp.textColor }}>
                      {feedData.title.split(" ")[0] + " "}
                      <span style={{ color: themeProp.spanYello }}>
                        {feedData.title.split(" ")[1] + " " + feedData.title.split(" ")[2]}
                      </span>
                    </div>
                    <div
                      className="heat-box"
                      style={{
                        border: themeProp.border || "1px solid #e8eaeb",
                        background: themeProp.bgColor || "#fff",
                        color: themeProp.textColor || "#000",
                      }}
                    >
                      <div className="heat-header" style={{ background: themeProp.headerFooterBg || "#f4f4f4" }}>
                        <div className="checkin-class-name">{feedData.className}</div>
                      </div>
                      <div className="participants-list">
                        {feedData.participants.map((participant, index) => (
                          <div
                            key={index}
                            className="participant-row"
                            style={{ borderBottom: themeProp.borderBottom || "1px solid #d0d0d0" }}
                          >
                            <div className="participant-name">{participant.username}</div>
                            <div className="participant-status">
                              <span>{participant.scratch || ""}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* No Data Message */}
        {onDeckHeat.length === 0 && backupHeat.length === 0 && !isLoader && (
          <div className="no-data-message" style={{ color: themeProp.textColor }}>
            <span>No Heat Information Available</span>
          </div>
        )}
      </div> )}
    </div>
  );
}